import {
  AvatarPopover,
  DarkModeToggle,
  EnvironmentBadge,
  FixedToolbarItem,
  Toolbar,
} from "@bagel-web/components";
import { CurrentUser } from "api/types";
import Image from "next/image";
import Link from "next/link";
import { Navbar } from "react-bootstrap";

const NavHeader = ({
  whoami,
  onLogOut,
}: {
  whoami?: CurrentUser | null;
  onLogOut: () => void;
}) => {
  return (
    <Navbar className="bg-primary px-3" id="header">
      <Navbar.Brand>
        <Link href="/" className="navbar-brand">
          <Image
            className="me-3"
            src="/static/logo-mark-yellow.svg"
            alt="Artificial Agency Logo"
            width={30}
            height={30}
            priority
            style={{
              verticalAlign: "top",
              filter: "brightness(0.2) grayscale(1)",
            }}
          />
          Admin
        </Link>
        <EnvironmentBadge />
      </Navbar.Brand>
      <Navbar.Collapse className="justify-content-end">
        <Toolbar>
          <FixedToolbarItem>
            <DarkModeToggle variant="dark" />
          </FixedToolbarItem>
          <FixedToolbarItem>
            {whoami && (
              <AvatarPopover
                variant="dark"
                whoami={{ user: { email: whoami.email, avatar_url: null } }}
                onLogOut={onLogOut}
              />
            )}
          </FixedToolbarItem>
        </Toolbar>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavHeader;
